module.exports = __webpack_public_path__ + "img/companion-download-image.9a19efaa.png";